export function normalizeFieldIds(field) {
  if (Array.isArray(field)) {
    return field.length ? field : ['ALL']
  }
  return [field || 'ALL']
}

const STATUS_KEYS = [0, 1, 2, 9]

export function getProgressDataForIds(tasksProgress, fieldIds) {
  if (!tasksProgress) {
    return emptyPayload()
  }

  if (fieldIds.length === 1) {
    return tasksProgress[fieldIds[0]] ?? emptyPayload()
  }

  const seen = new Set()
  const tasks = []
  for (const id of fieldIds) {
    for (const task of tasksProgress[id]?.tasks ?? []) {
      if (!seen.has(task.id)) {
        seen.add(task.id)
        tasks.push(task)
      }
    }
  }

  const payload = { tasks }
  for (const status of STATUS_KEYS) {
    const count = tasks.filter((task) => task.status === status).length
    payload[`tasks_${status}_percentage`] = count ? (count / tasks.length) * 100 : 0
  }

  return payload
}

function emptyPayload() {
  return {
    tasks: [],
    tasks_0_percentage: 0,
    tasks_1_percentage: 0,
    tasks_2_percentage: 0,
    tasks_9_percentage: 0
  }
}
